<template>
  <div class="container-fluid mt-6 px-5">
    <div class="row g-4 align-items-stretch">
      <div class="col-lg-4 col-md-6 d-flex">
        <monthly-cases-chart class="w-100" />
      </div>
      <div class="col-lg-4 col-md-6 d-flex">
        <cases-by-stage-pie class="w-100" />
      </div>
      <div class="col-lg-4 col-md-6 d-flex">
        <cases-by-insurance-type class="w-100" />
      </div>
    </div>
    <div class="row g-4 align-items-stretch">
      <div class="col-lg-4 col-md-6 d-flex">
        <top-warnings :warnings="warnings" class="w-100" />
      </div>
      <div class="col-lg-4 col-md-6 d-flex">
        <top-debtors class="w-100" />
      </div>
      <div class="col-lg-4 col-md-6">
        <cases-by-executor class="w-100" />
      </div>
    </div>
  </div>
</template>




<script>
import CasesByExecutor from "@/project/Dashboard/Components/CasesByExecutor.vue";
import MonthlyCasesChart from "@/project/Dashboard/Components/MonthlyCasesChart.vue";
import TopWarnings from "@/project/Dashboard/Components/TopWarnings.vue";
import TopDebtors from "@/project/Dashboard/Components/TopDebtors.vue";
import CasesByStagePie from "@/project/Dashboard/Components/CasesByStagePie.vue";
import CasesByInsuranceType from "@/project/Dashboard/Components/CasesByInsuranceType.vue";


// import { GetWarningJournal } from "@/project/Source/journals";

export default {
  components: {
    MonthlyCasesChart,
    TopWarnings,
    TopDebtors,
    CasesByExecutor,
    CasesByStagePie,
    CasesByInsuranceType
  },
  data() {
    return {
      warnings: [],
      loading: false
    };
  },
  mounted() {
    this.loadWarnings();
  },
  methods: {
    async loadWarnings() {
      this.loading = true;
      try {
        // const { data } = await GetWarningJournal({
        //   page: 1,
        //   pageSize: 50,
        //   searchText: ""
        // });
        this.warnings = [
          {
            subrogationNumber: "00001",
            statusName: "Məsul şəxs təyin olunub",
            description: "Məsul şəxs təyin olunub, işə başlamayıb",
            statusDate: "2025-05-23T00:00:00",
            subrogationId: 125,
            overdueDays: 38
          },
          {
            subrogationNumber: "00002",
            statusName: "Məsul şəxs təyin olunub",
            description: "Məsul şəxs təyin olunub, işə başlamayıb",
            statusDate: "2025-05-23T00:00:00",
            overdueDays: 38
          },
          {
            subrogationNumber: "00003",
            statusName: "Məhkəmə hazırlığına göndərilib",
            description: "Məhkəmə hazırlığı mərhələsindədir, lakin növbəti addım atılmayıb (Kamran Nəsibov)",
            statusDate: "2025-05-24T00:00:00",
            overdueDays: 35
          },
          {
            subrogationNumber: "00004",
            statusName: "Məhkəmə işi yaradılıb",
            description: "Məhkəmə işi yaradılıb, icraya göndərilməyib (Məhkəmə işi №1)",
            statusDate: "2025-05-25T00:00:00",
            overdueDays: 33
          },
          {
            subrogationNumber: "00005",
            statusName: "İcraya göndərilib",
            description: "İcraya göndərilib, lakin öhdəlik yerinə yetirilməyib (Məhkəmə işi №2)",
            statusDate: "2025-05-26T00:00:00",
            overdueDays: 30
          },
          {
            subrogationNumber: "00006",
            statusName: "Məhkəmə işi yaradılıb",
            description: "Məhkəmə işi yaradılıb, icraya göndərilməyib (Məhkəmə işi №3)",
            statusDate: "2025-05-27T00:00:00",
            overdueDays: 28
          },
          {
            subrogationNumber: "00007",
            statusName: "Məsul şəxs işə başlayıb",
            description: "İş başlanıb, lakin sənədlər daxil edilməyib",
            statusDate: "2025-05-28T00:00:00",
            overdueDays: 27
          },
          {
            subrogationNumber: "00008",
            statusName: "İcraya göndərilib",
            description: "İcraya göndərilib, lakin iştirakçının cavabı yoxdur",
            statusDate: "2025-05-29T00:00:00",
            overdueDays: 25
          },
          {
            subrogationNumber: "00009",
            statusName: "Məhkəmə hazırlığına göndərilib",
            description: "Məhkəmə hazırlığı mərhələsində gecikmə var",
            statusDate: "2025-05-30T00:00:00",
            overdueDays: 24
          },
          {
            subrogationNumber: "00010",
            statusName: "Məsul şəxs təyin olunub",
            description: "İcra qeydləri yoxdur",
            statusDate: "2025-06-01T00:00:00",
            overdueDays: 21
          }
        ];

      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped></style>
